module.exports = __webpack_public_path__ + "static/media/ionicons.24712f6c.ttf";